import React from "react";
import {Box, CloseDialogButton, Colors, Divider, Drawer, Text} from "@bounce/shared/ui";
import {SbtTemplate} from "../../apis/requests/sbt-templates/types";
import {SbtTemplateTypeChips} from "./SbtTemplateTypeChips";

type Props = {
  template: SbtTemplate | null;
  onClose: () => void;
};

export const SbtTemplateDrawer = ({template, onClose}: Props) => (
  <Drawer anchor="right" open={!!template} onClose={onClose}>
    <Box sx={{width: 420, p: 3, position: "relative"}}>
      <CloseDialogButton onClose={onClose} />
      {template && (
        <>
          <Text size={16} variant="interDisplay600" sx={{color: Colors.grey._900, mb: 0.5}}>
            Code {template.code}
          </Text>
          <Text size={14} sx={{color: Colors.grey._700, mb: 1.5}}>
            {template.name}
          </Text>
          <SbtTemplateTypeChips template={template} />
          <Divider sx={{my: 3}} />
          <Text size={16} variant="interDisplay600" sx={{color: Colors.grey._900, mb: 1}}>
            Message
          </Text>
          <Text size={14} sx={{color: Colors.grey._900, whiteSpace: "pre-wrap", wordBreak: "break-word"}}>
            {template.message}
          </Text>
        </>
      )}
    </Box>
  </Drawer>
);
